const formatPrice = (data) => {
   const temp = Number(data)
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, '$&.')
      .split('.');
   return `Rp${temp.slice(0, temp.length - 1).join('.')}`;
};
const formatPriceNoRp = (data) => {
   const temp = Number(data)
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, '$&.')
      .split('.');
   return `${temp.slice(0, temp.length - 1).join('.')}`;
};

export { formatPrice, formatPriceNoRp };
